//export const BASE_URL = "https://rekpark.kg";
//export const API_BASE_URL = "https://rekpark.kg/api";

export const BASE_URL = "https://srv725348.hstgr.cloud";
export const API_BASE_URL = "https://srv725348.hstgr.cloud/api";
export const IMAGE_DEFAULT = BASE_URL + "/images/logo_default.png";